import {RolePermissionBase} from '../database-models/role-permission-base';
import {ApplicationModuleBase} from '../database-models/application-module-base';
import {RoleBase} from '../database-models/role-base';
//Generated Imports
export class RolePermission extends RolePermissionBase 
{




//#region Generated Reference Properties
//#region applicationModule Prop
applicationModule : ApplicationModuleBase;
//#endregion applicationModule Prop
//#region role Prop
role : RoleBase;
//#endregion role Prop

//#endregion Generated Reference Properties

























}